(()=>{
const root=document.querySelector('.in[data-page]');
if(!root)return;
const cta=root.querySelector('[data-in-save]');
if(!cta)return;
let dict={};
try{dict=JSON.parse(root.querySelector('#in-i18n').textContent)||{};}catch(e){dict={};}
const t=(key,vars)=>{let text=dict[key]||key;if(vars)for(const name in vars)text=text.split('{'+name+'}').join(vars[name]);return text;};
const vat=Number(root.dataset.vat)||0;
const withVat=c=>vat?Math.ceil(c*(1000+vat)/100000)*100:c;
const rawLang=document.documentElement.lang||'en';
const routeRoot=root.dataset.root;
if(!routeRoot)return;
const abort=new AbortController();
const timer=setTimeout(()=>abort.abort(),8000);
/* Live saving from the store's own Gym Monster 3 product data. The label falls back to the plain text already in the page. */
fetch(routeRoot+'products/speediance-gym-monster-3.js',{signal:abort.signal}).then(response=>{if(!response.ok)throw new Error('Unavailable');return response.json();}).then(product=>{
 clearTimeout(timer);
 const wantId=Number(cta.getAttribute('data-in-variant'))||0;
 const usable=v=>v.available&&Number(v.price)>0;
 const variants=product.variants||[];
 /* Match by variant id first, then by SKU. Never by title: EU locales translate variant titles. */
 const variant=variants.find(v=>wantId&&Number(v.id)===wantId&&usable(v))||variants.find(v=>v.sku==='GM3STUDIO'&&usable(v));
 if(!variant)return;
 const currency=product.currency||(window.Shopify&&window.Shopify.currency&&window.Shopify.currency.active);
 if(!currency)return;
 const price=withVat(Number(variant.price)),compareAt=withVat(Number(variant.compare_at_price||0));
 if(!(compareAt>price))return;
 const money=amount=>new Intl.NumberFormat(rawLang,{style:'currency',currency,currencyDisplay:'narrowSymbol',minimumFractionDigits:0,maximumFractionDigits:0}).format(amount/100);
 cta.textContent=t('cta_save',{save:money(compareAt-price)});
}).catch(()=>{clearTimeout(timer);});
})();
